import { sanitizeConfigValue } from '../utils/sanitizeConfigValue';

// API Configuration for different environments
const resolveApiBaseUrl = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  const baseUrl = isProduction
    ? sanitizeConfigValue(process.env.REACT_APP_API_URL_PROD) ||
      sanitizeConfigValue(process.env.REACT_APP_API_BASE_URL) ||
      'https://api.tronallc.com'
    : sanitizeConfigValue(process.env.REACT_APP_API_BASE_URL) ||
      sanitizeConfigValue(process.env.REACT_APP_API_URL_DEV) ||
      'http://localhost:8080';

  return baseUrl.replace(/\/$/, '');
};

export const API_CONFIG = {
  BASE_URL: resolveApiBaseUrl(),

  // API Endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',

    // Companies
    COMPANIES: '/api/companies',
    COMPANIES_BY_USER: '/api/companies/by-user',

    // Orders
    ORDERS: '/api/orders',
    ORDER_FILES: '/api/orders/{id}/files',

    // Payments
    CREATE_PAYMENT_INTENT: '/api/create-payment-intent',

    // Files
    FILE_UPLOAD: '/api/files/upload',
    FILE_DOWNLOAD: '/api/files/download/{id}',
  },

  // Request configuration
  TIMEOUT: 30000, // 30 seconds

  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG;
